<template lang="jade">
  div.mcl-wrapper
    .input-group
      input.form-control(type="text", :placeholder="filterText", v-model="search", @focus="$event.target.select()")
      span.input-group-addon.glyphicon.glyphicon-filter(style="top: 0;")
    .mcl-items(:style="minHeight ? {'min-height': minHeight + 'px'} : {}")

      span(v-if="displayedData && !loading")
        virtualList(:size="38", :remain="5", :onscroll="loadMore", :bench="40")
          .checkbox.text-left(v-if="allowSelectAll && !disabled")
            label.to-click.select-all
              input(type="checkbox" v-model="selectVisible")
              span Selecionar todos visíveis
          .checkbox.text-left(v-for="(item, $index) in displayedData", :key="$index")
              MultiItemSelector(:useState="useState", :item="item", :uniqueKey="uniqueKey", :disabled="disabled",
                :formatName="formatName", :clickItem="clickItem")
          div(v-if="loading")
            .loading-bars(v-for="i in [1, 2, 3, 4, 5]" v-bind:style="{'width': Math.random() * (70 - 35) + 35 + '%'}") &nbsp;

</template>

<script>
import { removeDuplicatesArray } from '../../utils'
import ClickOutside from 'vue-click-outside'
import MultiItemSelector from './MultiItemSelector.vue'
import virtualList from 'vue-virtual-scroll-list'

export default {
  props: {
    allowSelectAll: {'default': true},
    paginate: {'default': true},
    filterText: {required: true},
    callback: {type: Function},
    useState: {required: true},
    onClick: {},
    minHeight: {type: String},
    customSearch: {type: Function}, // will not search in back, will search on loaded, formatName is necessary
    formatName: {},
    handdledLoading: {type: Boolean}, // outside handler of if is loading
    clickItem: {type: Function, 'default': null},
    disabled: {'default': false, type: Boolean},
    uniqueKey: {'default': 'id'}  // the default field of the object that the component will use to identify each item
  },
  async created () {
    this.loadItems(this.currentPage, '')
  },
  computed: {
    displayedData () {
      if (this.customSearch) {
        return this.customSearch(this.$getterUseState(this.useState).search, this.$getterUseState(this.useState).loaded)
      } else {
        return this.$getterUseState(this.useState).loaded
      }
    },
    loading () { return this.handdledLoading !== undefined ? this.handdledLoading : this.$getterUseState(this.useState).loading },
    currentPage () {
      return this.$getterUseState(this.useState).currentPage !== undefined ? this.$getterUseState(this.useState).currentPage : 0
    },
    totalPages () { return this.$getterUseState(this.useState).totalPages },
    search: {
      get () { return this.$getterUseState(this.useState).search },
      set (search) {
        if (this.customSearch) {
          this.$dispatchUseState(this.useState, {search})
        } else {
          this.$dispatchUseState(this.useState, {search, loaded: []})
          this.loadItems(0, search)
        }
      }
    },
    selectVisible: {
      get () { return this.$getterUseState(this.useState).selectVisible },
      async set (selected) {
        if (this.loading) { return }

        // here we commit all visible to be selected to not have daley in view while api is loading
        this.$commitUseState(this.useState, {selected: this.displayedData, loading: true})
        let updateState = {selectVisible: selected, loading: false}

        if (selected) {
          let toSelectOrDeselect = await this.callback({search: this.search})
          if (this.uniqueKey !== 'id') {
            updateState.loaded = this.parseUniqueKey(toSelectOrDeselect.body.success)
          } else {
            updateState.loaded = toSelectOrDeselect.body ? toSelectOrDeselect.body.success : []
          }
          updateState.selected = removeDuplicatesArray([...this.$getterUseState(this.useState).selected, ...updateState.loaded], this.uniqueKey)
        } else {
          const idsToRemove = this.$getterUseState(this.useState).loaded.map(i => i[this.uniqueKey])
          updateState.selected = this.$getterUseState(this.useState).selected.filter(i => !idsToRemove.includes(i[this.uniqueKey]))
        }

        this.$dispatchUseState(this.useState, updateState)
      }
    }
  },
  data () {
    return {
      popupVisible: false
    }
  },
  methods: {
    showPopup () { this.popupVisible = true },
    hidePopup () { this.popupVisible = false },
    onSelect (item) {
      this.$dispatchUseState(this.useState, {
        selected: [...this.$getterUseState(this.useState).selected, item]
      })
    },
    async loadItems (currentPage, search) {
      if (!this.callback) { return }

      this.$dispatchUseState(this.useState, {loading: true, selectVisible: false})

      let result = await this.callback({page: currentPage, search})
      if (!result.body) {
        // NO CONTENT
        this.$dispatchUseState(this.useState, {loading: false, loaded: []})
        return
      }

      if (this.uniqueKey !== 'id') {
        result.body.success = this.parseUniqueKey(result.body.success)
      }

      let parsedState = { loading: false }

      if (currentPage !== undefined) {
        parsedState = {
          ...parsedState,
          loaded: removeDuplicatesArray([...this.displayedData, ...result.body.success], this.uniqueKey),
          currentPage: currentPage,
          totalPages: result.body.totalPages || 1
        }
      } else {
        parsedState = {
          ...parsedState,
          loaded: result.body.success
        }
      }
      this.$dispatchUseState(this.useState, parsedState)
    },
    loadMore (event) {
      const el = event.target
      if (el.offsetHeight + el.scrollTop >= el.scrollHeight) {
        if (!this.totalPages || this.currentPage + 1 < this.totalPages) {
          this.loadItems(this.currentPage + 1, this.search)
        }
      }
    },
    parseUniqueKey (data) {
      // If the back respond items only as a list, e.g: ['Local A', 'Local b'] we use item itselt as name and id
      // otherwise we will assume that is a list of objects and the coder want a custom unique key
      if (data && data[0][this.uniqueKey] === undefined) {
        data = data.map(item => { return {name: item, id: item} })
      } else {
        data = data.map(item => { return {name: item.name, id: item[this.uniqueKey]} })
      }
      return data
    }
  },
  components: { MultiItemSelector, virtualList },
  directives: { ClickOutside }
}
</script>

<style scoped>
  .pop-up-size {
    width: 65%;
    max-height: 200px;
    overflow: scroll;
  }
  .select-all { margin-left: 10px; }
  .loading-bars {
    background-color: whitesmoke;
    height: 17px;
    margin: 8px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// MultiSelect.vue?184b5076